import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
  HTMLAnchorElementDirective,
  HTMLSectionElementDirective,
  TabDirective,
  TabLabelComponent,
  TabPanelComponent,
  TabsComponent,
  HeaderDirective,
  FooterDirective,
} from "./tabs.component";

@NgModule({
  declarations: [
    TabsComponent,
    TabDirective,
    TabPanelComponent,
    TabLabelComponent,
    HeaderDirective,
    FooterDirective,
    HTMLAnchorElementDirective,
    HTMLSectionElementDirective,
  ],
  imports: [CommonModule],
  exports: [TabsComponent, TabDirective, TabPanelComponent, TabLabelComponent, HeaderDirective, FooterDirective],
})
export class TabsModule {}
